<template>
    <div class=".container">
        <!-- モーダルウィンドウ -->
        <div v-if="modal_flag">
            <div class="modal" v-on:click.self="removeFlag()">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title">{{ modal_title }}</h4>
                        </div>
                        <div class="modal-body" style="white-space:pre-wrap; word-wrap:break-word;">{{ modal_message }}</div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-outline-success w-100" v-on:click="removeFlag()">確認</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-backdrop show"></div>
        </div>
    </div>
</template>

<script>
export default {
    name:"AlertModal",
    methods:{
        removeFlag(){
            this.modal_flag=!this.modal_flag;
        },
    },
    computed:{
        /**
         * モーダル表示フラグ(storeとの双方向算出プロパティ)
         */
        modal_flag:{
            get(){return this.$store.getters["alertModal/getFlag"]},
            set(){this.$store.dispatch("alertModal/changeFlagState")},
        },
        /**
         * モーダルのタイトル(storeとの双方向算出プロパティ)
         */
        modal_title:{
            get(){return this.$store.getters["alertModal/getTitle"]},
            set(new_value){this.$store.dispatch("alertModal/saveTitle",new_value)},
        },
        /**
         * モーダルのメッセージ(storeとの双方向算出プロパティ)
         */
        modal_message:{
            get(){return this.$store.getters["alertModal/getMessage"]},
            set(new_value){this.$store.dispatch("alertModal/saveMessage",new_value)},
        },
    }
}
</script>

<style scoped>
.modal {
    display: block;
}
.btn-outline-success {
    color: #00db5b;
    border-color: #00db5b;
}
.btn-outline-success:hover {
    color: white;
    background-color: #00db5b;
}
</style>